import React from 'react';
import { connect } from 'react-redux';
import { Trans } from '@lingui/react/macro';
import theme from './ItemCategoryDisplay.module.scss';
import { IState } from '@/state/IState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { findCategory } from '@/utils/categories';
import { classnames } from '@/utils/html';

const mapStateToProps = (state: IState) => ({
    itemCategories: state.global.itemCategories,
});

type OwnProps = ReturnType<typeof mapStateToProps> & {
    value: number | null;
    lowercase?: boolean;
    type?: 'self' | 'full' | 'root';
    className?: string;
};

const ItemCategoryDisplay: React.FC<OwnProps> = ({ itemCategories, value, lowercase = false, type = 'full', className }) => {
    if (!itemCategories) {
        return null;
    }

    if (!value) {
        return (
            <React.Fragment>
                <Trans>No category</Trans>
            </React.Fragment>
        );
    }

    const result = findCategory(itemCategories, +value);

    if (!result.node) {
        return null;
    }
    // full
    let categoriesToDisplay = result.path.reverse();

    if (type === 'self') categoriesToDisplay = [result.node];
    if (type === 'root') categoriesToDisplay = [result.path[0]];

    return (
        <span className={classnames(theme.container, className)}>
            {categoriesToDisplay.map((cat, index) => (
                <React.Fragment key={cat.id}>
                    <span className={theme.category}>{lowercase ? cat.name.toLowerCase() : cat.name}</span>

                    {index < categoriesToDisplay.length - 1 && <FontAwesomeIcon icon={faAngleRight} fixedWidth />}
                </React.Fragment>
            ))}
        </span>
    );
};

export default connect(mapStateToProps)(ItemCategoryDisplay);